import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { Store } from '@ngrx/store';

import { selectCurrentTemperature } from './temperature-store/temperature.selector';
import { TemperatureComponent } from './temperature.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'era-temperature',
  templateUrl: './temperature.container.html',
  imports: [TemperatureComponent],
})
export class TemperatureContainerComponent {
  private readonly store = inject(Store);

  public readonly currentTemperature = this.store.selectSignal(selectCurrentTemperature);
}
